// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main_container {
  width: 100%;
  justify-content: center;
  min-width: 1080px;
}
.layout_container {
  display: flex;
  flex-flow: column;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/shared/Layout/layout.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".main_container {\n  width: 100%;\n  justify-content: center;\n  min-width: 1080px;\n}\n.layout_container {\n  display: flex;\n  flex-flow: column;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
